class ProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quantityChange = event => this.handleQuantityChange(event);
    window.addEventListener('quantity-change', this.quantityChange);

    this.storeVisitedProducts();
  }

  disconnectedCallback() {
    window.removeEventListener('quantity-change', this.quantityChange);
  }

  storeVisitedProducts() {
    const productHandleString = this.dataset.productUrl;
    let updatedVisitedProductsArray = [];
    const visitedProducts = localStorage.getItem('visited-products');

    // set localStorage if it's empty
    if (visitedProducts === null) {
      localStorage.setItem('visited-products',JSON.stringify([productHandleString]));
    }
    else {
      const visitedProductsArray = JSON.parse(visitedProducts);

      // if item is already logged, move it to the end, so it's the last visited product, return
      if (visitedProductsArray.includes(productHandleString)) {
        visitedProductsArray.push(visitedProductsArray.splice(visitedProductsArray.indexOf(productHandleString), 1)[0]);
        localStorage.setItem('visited-products',JSON.stringify(visitedProductsArray));
        return;
      }
      else {
        const productHandleStringHandle = productHandleString.split('/products/')[1];
        let inArray = false;

        for (let index = 0; index < visitedProductsArray.length; index++) {
          const itemInArray = visitedProductsArray[index];
          const productHandleInArray = itemInArray.split('/products/')[1];

          if (productHandleInArray === productHandleStringHandle) {
            inArray = true;
            break;
          }
        }
        // add the new item because it's not in the array yet
        if (!inArray) {
          updatedVisitedProductsArray = visitedProductsArray.concat([productHandleString]);
        }
      }
      // update localStorage with new product
      localStorage.setItem('visited-products',JSON.stringify(updatedVisitedProductsArray));
    }
  }

  handleQuantityChange(event) {
    const { quantity, id } = event.detail;
    this.productForm = document.getElementById(`product-form-${id}`);
    if (!this.productForm) return;

    this.productForm.querySelector('input[name="quantity"]').value = quantity;
  }
}
if (!customElements.get('product-info')) {
  customElements.define('product-info', ProductInfo);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productForm = document.querySelector('[data-product-form]');
    this.quickAddWrapper = this;
    this.fixedClass = 'is-fixed';
    this.productId = this.dataset.productId;
    const uspWrapper = document.querySelector(`.product-info-usps--${this.productId}`);

    // On scroll, observe the product form on mobile and make it fixed when necessary
    this.debouncedOnScroll = () => {
      // Clone the info USP's
      if (uspWrapper && window.windowWidth >= 1024) {
        if (this.querySelector('[data-add-to-cart-usps]').innerHTML === '') {
          const newNode = uspWrapper.cloneNode(true);
          newNode.classList.remove('flex-col');
          this.querySelector('[data-add-to-cart-usps]').appendChild(newNode);
        }
        else {
          this.querySelector('[data-add-to-cart-usps]').classList.remove('hidden');
        }
      }
      else if (this.querySelector('[data-add-to-cart-usps]').innerHTML !== '') {
        this.querySelector('[data-add-to-cart-usps]').classList.add('hidden');
      }

      // check for window height for accessibility. We don't fix the element for small screens
      if (window.windowHeight > 480) this.productInfoObserver();
    };

    window.addEventListener('window:scroll', this.debouncedOnScroll);
    window.addEventListener('window:resize', this.debouncedOnScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('window:scroll', this.debouncedOnScroll);
    window.removeEventListener('window:resize', this.debouncedOnScroll);
  }

  /**
   * productInfoObserver
   * @description Observe the product form and add/remove the sticky class when necessary.
   */
  productInfoObserver() {
    // Register IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Check if the top of the element is at or above the top of the viewport
        const isTopVisible = entry.boundingClientRect.top <= 0;
        if (isTopVisible) {
          if (this.quickAddWrapper.classList.contains(this.fixedClass)) return;

          this.quickAddWrapper.classList.add('hiding');
          setTimeout(() => {
            this.quickAddWrapper.classList.add(this.fixedClass);
            this.quickAddWrapper.classList.remove('hiding');
          }, 500);
          // set the height of the element to the same height as the wrapper so there's no jump when the sticky (fixed) class is applied. Also wait a bit because the dynamic checkout might be loaded later
          setTimeout(() => {
            document.body.style.paddingBottom = `${this.quickAddWrapper.children[0].clientHeight}px`;
          }, 500);
        }
        else {
          this.quickAddWrapper.classList.remove(this.fixedClass);
          document.body.style.paddingBottom = 0;
        }
      });
    });

    // Declares what to observe, and observes its properties.
    observer.observe(this.productForm);
  }
}
if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}